export const INVENTORY_CHILD_ROUTES = [
  '/inventory/dashboard',
  '/inventory/new',
  '/inventory/kits',
  '/inventory/parameters',
  '/inventory/vendors',
];

function pushLinks(items, links) {
  items.push(...links.filter(Boolean));
}

function pushSection(items, title, links) {
  const visible = links.filter(Boolean);
  if (visible.length === 0) return;
  items.push({ label: title, isHeader: true });
  items.push(...visible);
}

export function hasInventorySidebarAccess(hasMenuAccess, hasMenuAccessOrChild) {
  const showFieldOnly =
    (hasMenuAccess('/inventory/mobile') || hasMenuAccess('/inventory/new'))
    && !hasMenuAccess('/inventory');

  return showFieldOnly || hasMenuAccessOrChild('/inventory', INVENTORY_CHILD_ROUTES);
}

/** Flyout links for Inventory under Administration (single row › panel). */
export function buildInventoryFlyoutItems(hasMenuAccess) {
  const items = [];
  const showFieldOnly =
    (hasMenuAccess('/inventory/mobile') || hasMenuAccess('/inventory/new'))
    && !hasMenuAccess('/inventory');

  if (showFieldOnly) {
    pushLinks(items, [
      (hasMenuAccess('/inventory/mobile') || hasMenuAccess('/inventory'))
        ? { label: 'Field entry (mobile hub)', path: '/inventory/mobile' }
        : null,
      (hasMenuAccess('/inventory/new') || hasMenuAccess('/inventory'))
        ? { label: 'New asset', path: '/inventory/mobile/new' }
        : null,
    ]);
    return items;
  }

  pushLinks(items, [
    (hasMenuAccess('/inventory/dashboard') || hasMenuAccess('/inventory'))
      ? { label: 'Inventory Dashboard', path: '/inventory' }
      : null,
    hasMenuAccess('/inventory/new')
      ? { label: 'New Asset', path: '/inventory/new' }
      : null,
    hasMenuAccess('/inventory/kits')
      ? { label: 'Equipment Kits', path: '/inventory/kits' }
      : null,
    (hasMenuAccess('/inventory/mobile') || hasMenuAccess('/inventory'))
      ? { label: 'Field entry (mobile hub)', path: '/inventory/mobile' }
      : null,
  ]);

  pushSection(items, 'Configuration', [
    hasMenuAccess('/inventory/parameters')
      ? { label: 'Parameters', path: '/inventory/parameters' }
      : null,
    hasMenuAccess('/inventory/vendors')
      ? { label: 'Vendors / Suppliers', path: '/inventory/vendors' }
      : null,
  ]);

  return items;
}
